import { ref } from 'vue';
import { breakpoints } from '@app/utils/constants';

const matchMediaSmall = window.matchMedia(
  `screen and (min-width:${breakpoints['$bs-xs']}) and (max-width:${breakpoints['$bs-md']})`
);
const matchMediaMedium = window.matchMedia(
  `screen and (min-width:${breakpoints['$bs-md']}) and (max-width:${breakpoints['$bs-lg']})`
);
const matchMediaGtMedium = window.matchMedia(`screen and (min-width:${breakpoints['$bs-md']})`);
const matchMediaLarge = window.matchMedia(`screen and (min-width:${breakpoints['$bs-lg']})`);

const isSmallScreen = ref<boolean>(false);
const isMediumScreen = ref<boolean>(false);
const isGtMediumScreen = ref<boolean>(false);
const isLargeScreen = ref<boolean>(false);

const setWidth = () => {
  isSmallScreen.value = matchMediaSmall.matches;
  isMediumScreen.value = matchMediaMedium.matches;
  isGtMediumScreen.value = matchMediaGtMedium.matches;
  isLargeScreen.value = matchMediaLarge.matches;
};

export { setWidth, isLargeScreen, isMediumScreen, isGtMediumScreen, isSmallScreen };
